import { jsxs as x, Fragment as h, jsx as s } from "react/jsx-runtime";
import { useState as j, useRef as w, useEffect as I } from "react";
import { getFeaturedList as y } from "../utils/getFeaturedList.js";
import { getFeaturedListImages as A } from "../utils/getFeaturedListImages.js";
import { FeaturedList as C } from "../components/FeaturedList/FeaturedList.js";
import { Loading as E } from "../components/Loading/Loading.js";
function v({
  numberOfPrograms: i = 4,
  startTime: a = "11:00",
  endTime: o = "23:00",
  type: u = "series",
  canUseSameDay: n = !1,
  handleClicks: m = () => !0,
  hasSeriesPages: f = !0,
  loadingMessage: d = "",
  fallbackImage: e = { url: "" },
  getResource: r = () => !0,
  SCHEDULE_ENDPOINT: l,
  NETWORK: L
}) {
  const [t, p] = j(null), c = w({
    type: u,
    startTime: a,
    endTime: o,
    numberOfPrograms: i,
    canUseSameDay: n,
    SCHEDULE_ENDPOINT: l,
    NETWORK: L
  });
  return I(() => {
    t === null && (async () => {
      const g = await y(c.current), F = await A({ featuredList: g, fallbackImage: e, getResource: r });
      p(F);
    })();
  }, [t, e, r]), /* @__PURE__ */ x(h, { children: [
    t === null && /* @__PURE__ */ s(E, { message: d }),
    t !== null && /* @__PURE__ */ s(
      C,
      {
        list: t,
        hasSeriesPages: f,
        imageAspectRatio: 0.6775300171526587,
        handleClicks: m
      }
    )
  ] });
}
export {
  v as default
};
